import {
  fuseDetailConstants,
  createFuseConstants,
  editFuseConstants,
  countryListConstants,
  fuseKPISConstants,
} from "../_redux-constants";
import { fuseDetailService } from "../../_services";

function getFuseDetailLoad() {
  return { type: fuseDetailConstants.FUSE_DETAIL_LOADING };
}

function fuseDetailSuccess(data) {
  return { type: fuseDetailConstants.FUSE_DETAIL_SUCCESS, data };
}

function FuseListFailure(error) {
  return { type: fuseDetailConstants.FUSE_DETAIL_FAILURE, error };
}

function getFuseDetail(fuseId) {
  return (dispatch) => {
    dispatch(getFuseDetailLoad());
    return new Promise((resolve, reject) => {
      fuseDetailService.getFuseDetails(fuseId).then(
        (data) => {
          dispatch(fuseDetailSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(FuseListFailure(error?.toString()));
          reject(error);
        }
      );
    });
  };
}

function clearEditFuseData() {
  return {
    type: createFuseConstants.CLEAR_EDIT_FUSE,
  };
}

function editFuseDetailLoad() {
  return { type: editFuseConstants.EDIT_FUSE_LOADING };
}

function editFuseDetailSuccess() {
  return { type: editFuseConstants.EDIT_FUSE_SUCCESS };
}

function editFuseListFailure(error) {
  return { type: editFuseConstants.EDIT_FUSE_FAILURE, error };
}

function editFuseDetails(fuseId, payload) {
  return (dispatch) => {
    dispatch(editFuseDetailLoad());
    return fuseDetailService.editFuseDetailService(fuseId, payload).then(
      () => {
        dispatch(editFuseDetailSuccess());
      },
      (error) => {
        dispatch(editFuseListFailure(error?.toString()));
      }
    );
  };
}

function clearCreateFuseData() {
  return {
    type: createFuseConstants.CLEAR_CREATE_FUSE,
  };
}

function createFuseLoad() {
  return { type: createFuseConstants.CREATE_FUSE_LOADING };
}

function createFuseSuccess(data) {
  return { type: createFuseConstants.CREATE_FUSE_SUCCESS, data };
}

function createFuseFailure(error) {
  return { type: createFuseConstants.CREATE_FUSE_FAILURE, error };
}

function createFuse(requestBody) {
  return (dispatch) => {
    dispatch(createFuseLoad());
    return fuseDetailService.createFuse(requestBody).then(
      (data) => {
        dispatch(createFuseSuccess(data));
      },
      (error) => {
        dispatch(createFuseFailure(error));
      }
    );
  };
}

function countryListLoad() {
  return { type: countryListConstants.COUNTRY_LIST_LOADING };
}

function countryListSuccess(data) {
  return { type: countryListConstants.COUNTRY_LIST_SUCCESS, data };
}

function countryListFailure(error) {
  return { type: countryListConstants.COUNTRY_LIST_FAILURE, error };
}

function getCountryList() {
  return (dispatch) => {
    dispatch(countryListLoad());
    fuseDetailService.getCountryList().then(
      (data) => {
        dispatch(countryListSuccess(data));
      },
      (error) => {
        dispatch(countryListFailure(error?.toString()));
      }
    );
  };
}

function getFuseKPILoad() {
  return { type: fuseKPISConstants.FUSE_KPI_LOADING };
}

function getFuseKPISuccess(data) {
  return { type: fuseKPISConstants.FUSE_KPI_SUCCESS, data };
}

function getFuseKPIFailure(error) {
  return { type: fuseKPISConstants.FUSE_KPI_FAILURE, error };
}

function getFuseKPIDetails(serialNumber) {
  return (dispatch) => {
    dispatch(getFuseKPILoad());
    fuseDetailService.getFuseKPIDetails(serialNumber).then(
      (data) => {
        dispatch(getFuseKPISuccess(data));
      },
      (error) => {
        dispatch(getFuseKPIFailure(error?.toString()));
      }
    );
  };
}

export const fuseDetailActions = {
  getFuseDetail,
  editFuseDetails,
  createFuse,
  getCountryList,
  clearCreateFuseData,
  clearEditFuseData,
  getFuseKPIDetails,
};
